import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M15.498 3.443a.75.75 0 0 1 1.06.055l4.5 5A.75.75 0 0 1 20.5 9.75h-17a.75.75 0 0 1 0-1.5h15.316l-3.373-3.748a.75.75 0 0 1 .055-1.06Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8.502 20.558a.75.75 0 0 1-1.06-.056l-4.5-5A.75.75 0 0 1 3.5 14.25h17a.75.75 0 0 1 0 1.5H5.184l3.373 3.748a.75.75 0 0 1-.055 1.06Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorTransfer;
